var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-toolbar',{staticClass:"md-dense"},[_c('div',{staticClass:"md-toolbar-section-start"},[_c('span',[_vm._v(_vm._s(_vm._f("upper")(_vm.L(_vm.$route.name))))])]),_c('div',{staticClass:"md-toolbar-section-end"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }